import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { MetricCard } from '../metricCard/MetricCard';
import { PayoutSummary } from '../payoutSummary/PayoutSummary';
import {
  useGetEmployeeMetricPayoutStatusQuery,
  useGetEmployeePayoutDetailsQuery,
  useGetMonthlyMetricsSummaryQuery,
} from '../../pages/metricdashboard/metricDashboardSlice';
import { selectCurrentRole } from '../../pages/login/authSlice';
import { payqualifiersFormat } from '../../features/scorecardRulesAndActivity/scorecardPayoutCriteria/scorecard-payout-criteria-service';
import { AGENTROLE, SUPERVISORROLE } from '../../constants';
import { ConstScorecardRole } from '../../utils/typeConstants';
import { getMonthName } from '../../utils/dateFormat';
import './MetricQualifiers.scss';
import device from '../../assets/Device.png';

interface MetricQualifiersProps {
  empNum?: string;
  inputMonth: number;
  inputYear: number;
  scorecardVersionID: number | string;
}

export const MetricQualifiers = ({
  empNum,
  inputMonth,
  inputYear,
  scorecardVersionID,
}: MetricQualifiersProps) => {
  const role = useSelector(selectCurrentRole);
  const [payoutDetails, setpayoutDetails] = useState<any>([]);
  const [qualifiers, setQualifiers] = useState<any>([]);
  const [scorecardRoleId, setScorecardRoleId] = useState<number>(0);
  const [monthlyMetrics, setMonthlyMetrics] = useState<any>([]);

  useEffect(() => {
    if (role === AGENTROLE) {
      setScorecardRoleId(ConstScorecardRole.ASSOCIATE);
    } else if (role === SUPERVISORROLE) {
      setScorecardRoleId(ConstScorecardRole.TEAM_LEAD);
    } else {
      setScorecardRoleId(0);
    }
  }, [role]);

  const { data: payoutData, isFetching: ispayoutFetching } = useGetEmployeePayoutDetailsQuery(
    {
      employeenumber: empNum,
      year: inputYear,
      month: inputMonth,
      scorecardversionid: scorecardVersionID ?? 0,
      scorecardroleid: scorecardRoleId,
    },
    {
      skip: !empNum || !inputYear || !inputMonth || !scorecardRoleId,
    }
  );

  const { data: monthlyMetricsData } = useGetMonthlyMetricsSummaryQuery(
    {
      employeenumber: empNum,
      year: inputYear,
      month: inputMonth,
      scorecardversionid: scorecardVersionID ?? 0,
      scorecardroleid: scorecardRoleId,
    },
    {
      skip: !empNum || !inputYear || !inputMonth || !scorecardRoleId,
    }
  );

  const { data: metricPayoutStatusData } = useGetEmployeeMetricPayoutStatusQuery(
    {
      employeenumber: empNum,
      year: inputYear,
      month: inputMonth,
    },
    { skip: !empNum }
  );

  useEffect(() => {
    if (monthlyMetricsData?.data.length > 0) {
      setMonthlyMetrics(monthlyMetricsData?.data);
    } else setMonthlyMetrics([]);
  }, [monthlyMetricsData]);

  useEffect(() => {
    if (!ispayoutFetching && payoutData?.data.length > 0) {
      setpayoutDetails(payoutData?.data);
      if (payoutData?.data[0]?.pay_qualifiers && payoutData?.data[0]?.pay_qualifiers.length > 0) {
        setQualifiers(payoutData?.data[0]?.pay_qualifiers);
      } else setQualifiers([]);
    } else setpayoutDetails([]);
  }, [payoutData]);

  const payoutStatusData = metricPayoutStatusData?.data?.filter(
    (item: any) => item.scorecard_version_id === scorecardVersionID
  ) ?? [];

  const backgroundColor = (label: string) => {
    switch (label) {
      case 'Attendance':
        return '#B5EBE5';
      case 'Corrective Actions':
        return '#C0E0FF';
      case 'Worked Hours':
        return '#D4D4FF';
      default:
        return '#FFFFFF';
    }
  };

  if (payoutDetails?.length > 0) {
    return (
      // <div className="p-4 border-round-xl shadow-sm bg-white">
      <div className="qualifiers-wrapper">
        <h3 className="mb-3">Metric Qualifiers</h3>
        <div className="qualifiers-box">
          <p className="fs-5 mb-3">
            {getMonthName(inputMonth)} {inputYear}
          </p>

          <div className="qualifier-scroll-container">
            <div className="qualifier-scroll-row">
              {qualifiers.length > 0 &&
                qualifiers.map((qualifier: any, idx: number) => (
                  <MetricCard
                    key={qualifier?.id || qualifier?.label || idx}
                    label={qualifier.label}
                    value={payqualifiersFormat(
                      qualifier.pay_qualifier_value,
                      qualifier.metric_type_name
                    )}
                    target={payqualifiersFormat(
                      qualifier.qualifier_target,
                      qualifier.metric_type_name
                    )}
                    qualifierMet={qualifier.qualifier_eligible}
                    backgroundColor={backgroundColor(qualifier.label)}
                  />
                ))}
              {qualifiers.length === 0 && <div className="col-md-12">No Qualifiers</div>}

              <PayoutSummary
                monthlyMetrics={monthlyMetrics}
                selectedmetrics={payoutStatusData[0] ?? null}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }


  return (
    <div className="qualifiers-wrapper">
      <h3 className="mb-3">Metric Qualifiers</h3>

      <div className="qualifiers-no-data">
        <div className="no-data-wrapper">
          <div className="no-data-text">No Data<br />Available</div>
          <img className="no-data-image" src={device} alt="No Data" />
        </div>
      </div>
    </div>
  );
};
